import { EdgeProps } from "reactflow";
import BaseEdge from "./base/BaseEdge";

export const CraftingStationIdEdge = (edgeProps: EdgeProps) => {
  return <BaseEdge {...edgeProps} color={"blue.400"} />;
};
